const BREAKPOINTS = {
  MEDIUM: 650,
  LARGE: 1e3
};
export {
  BREAKPOINTS
};
//# sourceMappingURL=globals.js.map
